// app/composables/bracket/useBracketMetaDetection.ts

import type { Phase } from "~/src/season-cluster/domain/models/02.Phase";

/**
 * Checks if any match in the playoff phase has bracket_config in metaInformation
 */
export function useBracketMetaDetection() {
  function hasBracketMetaConfig(phase: Phase | undefined): boolean {
    if (!phase) return false;

    for (const group of phase.groups) {
      for (const turn of group.turns) {
        for (const match of turn.matches) {
          if (match.metaInformation?.bracket_config) {
            return true;
          }
        }
      }
    }

    return false;
  }

  return {
    hasBracketMetaConfig,
  };
}
